import { Link } from "react-router-dom";
import { ArrowUpRight, Bot, Workflow, Search, Facebook, Music2, Filter, Trophy } from "lucide-react";

const items = [
  {
    to: "/automatizacion-ia",
    icon: Bot,
    title: "Automatización con IA",
    desc: "Agentes IA, chatbots y flujos omnicanal que califican y venden 24/7.",
    cta: "Conocer automatización IA",
  },
  {
    to: "/respond-io",
    icon: Workflow,
    title: "Respond.io",
    desc: "Centralizo tus canales en una sola bandeja con automatización empresarial.",
    cta: "Explorar Respond.io",
  },
  {
    to: "/google-ads",
    icon: Search,
    title: "Google Ads",
    desc: "Campañas de intención con tracking quirúrgico y leads calificados.",
    cta: "Ver servicio de Google Ads",
  },
  {
    to: "/meta-ads",
    icon: Facebook,
    title: "Meta Ads",
    desc: "Facebook + Instagram Ads con remarketing y escalabilidad real.",
    cta: "Ver Meta Ads",
  },
  {
    to: "/tiktok-ads",
    icon: Music2,
    title: "TikTok Ads",
    desc: "Adquisición moderna con creatividades que sí convierten.",
    cta: "Ver TikTok Ads",
  },
  {
    to: "/funnels",
    icon: Filter,
    title: "Funnels de venta",
    desc: "Tráfico → automatización → calificación → ventas. Sistema completo.",
    cta: "Ver funnels",
  },
  {
    to: "/casos-de-exito",
    icon: Trophy,
    title: "Casos de éxito",
    desc: "Resultados, métricas, testimonios y automatizaciones implementadas.",
    cta: "Ver casos de éxito",
  },
];

export default function ServicesOverview() {
  return (
    <section id="services-overview" data-testid="services-overview-section" className="relative py-24 sm:py-32">
      <div className="container-x">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 reveal">
          <div className="max-w-2xl">
            <div className="eyebrow mb-5">Servicios</div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
              Un ecosistema completo para <span className="text-gradient">vender más</span>.
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md text-base">
            Cada vertical tiene su propia página con detalles, mockups y ejemplos. Selecciona la que más se ajuste a tu necesidad actual.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {items.map(({ to, icon: Icon, title, desc, cta }, i) => (
            <Link
              key={to}
              to={to}
              data-testid={`service-overview-${to.replace("/", "")}`}
              className={`reveal grad-border p-7 card-lift relative overflow-hidden block ${
                i === 0 ? "sm:col-span-2 lg:col-span-2 xl:col-span-2" : ""
              }`}
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              {i === 0 && (
                <div className="absolute -right-16 -top-10 w-56 h-56 rounded-full bg-gradient-to-br from-[#ff3b1f]/30 to-transparent blur-3xl pointer-events-none" />
              )}
              <div className="flex items-start justify-between gap-4">
                <div className="w-12 h-12 rounded-xl bg-gradient-brand grid place-items-center text-black/90 shadow-lg shrink-0">
                  <Icon className="w-5 h-5" strokeWidth={2.4} />
                </div>
                <ArrowUpRight className="w-5 h-5 text-zinc-500 group-hover:text-white transition" />
              </div>
              <h3 className="mt-5 font-display font-semibold text-white text-lg tracking-tight">{title}</h3>
              <p className="mt-2 text-zinc-400 text-sm leading-relaxed">{desc}</p>
              <div className="mt-5 inline-flex items-center gap-1.5 text-[12px] tracking-[0.18em] uppercase text-[#ff8a00] font-display font-semibold">
                {cta} <ArrowUpRight className="w-3.5 h-3.5" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
